module.exports = __webpack_public_path__ + "static/media/vivaticket-card.8cab546a.png";